import { useGetList, useTimeout } from "ra-core";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";

interface TasksListFilterProps {
  title: string;
  filter: Record<string, any>;
  filterByContact?: string;
}

export const TasksListFilter = ({ title, filter, filterByContact }: TasksListFilterProps) => {
  const oneSecondHasPassed = useTimeout(1000);
  
  const filterWithContact = filterByContact 
    ? { ...filter, "contact_id@eq": filterByContact }
    : filter;

  const { data, isPending } = useGetList("tasks", {
    filter: filterWithContact,
    pagination: { page: 1, perPage: 10 },
    sort: { field: "due_date", order: "ASC" },
  });

  if (!oneSecondHasPassed) {
    return null;
  }

  if (isPending) {
    return (
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <h3 className="font-medium">{title}</h3>
          <Skeleton className="w-8 h-5 rounded-full" />
        </div>
        <div className="space-y-1">
          {Array.from({ length: 2 }).map((_, index) => (
            <Skeleton key={index} className="w-full h-8" />
          ))}
        </div>
      </div>
    );
  }

  const tasks = data || [];

  if (tasks.length === 0) {
    return null;
  }

  return (
    <Card className="p-3">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-medium text-sm">{title}</h3>
        <Badge variant="secondary" className="text-xs">
          {tasks.length}
        </Badge>
      </div>
      <div className="space-y-1">
        {tasks.map((task: any) => (
          <div key={task.id} className="text-sm p-2 rounded hover:bg-muted/50 transition-colors">
            <div className="font-medium">{task.subject}</div>
            {task.contact_name && (
              <div className="text-xs text-muted-foreground">{task.contact_name}</div>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
};
